/**
 * Created by joerg on 14.06.17.
 */
import React from 'react';


import {withRouter} from 'react-router-dom'
import Utils from '../utils/Utils'


class Startscreen extends React.Component {
    _goWartung = () =>{
        this.props.history.push(`/${Utils.serverpath}/entry`)
    }
    render(){
        const self = this;
        return(
            <div>
                <div className="row">
                    <div className="col-md-12"> Willkommen</div>
                </div>

            </div>
        )
    }
}
export default withRouter(Startscreen);


// WEBPACK FOOTER //
// ./src/components/Startscreen.js